export default "/images/logo-14.png?566d6cd4a011fec7deabd7e98d4b30ea";